var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"scheduleApp"}},[_c(_vm.view,{tag:"component"}),_c('div',{class:`category-${_vm.mediaquery}`,staticStyle:{"padding-top":"2rem","font-size":"1.4rem"}},[_vm._v(" "+_vm._s(_vm.priceText)+" ")]),_c('div',{staticClass:"tooltipContainer",staticStyle:{"display":"none"},attrs:{"id":"tooltip"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }